export const MAX_MEASURE_NAME_LENGTH = 25;

export const getTruncatedMeasureName = (name) => {
  if (!name) return "";
  return name.length > MAX_MEASURE_NAME_LENGTH
    ? `${name.slice(0, MAX_MEASURE_NAME_LENGTH)}...`
    : name;
};
